<template>
    <button
        v-if="type === 'umbrella'"
        :class="['umbrella-button', { selected: isSelected }]"
        type="button"
        @click.prevent="buttonClicked"
    >
        <umbrella-icon :fill-style="fillStyle.umbrella" />
    </button>
    <button
        v-if="type === 'station'"
        :class="['station-button text-white']"
        type="button"
        @click.prevent="buttonClicked"
    >
        <station-icon :id="thisId" :fill-style="fillStyle.station" />
    </button>
</template>

<script>
import StationIcon from "@/Pages/Home/Checkout/partials/svg/StationIcon.vue";
import UmbrellaIcon from "@/Pages/Home/Checkout/partials/svg/UmbrellaIcon.vue";

export default {
  components: { StationIcon, UmbrellaIcon },
  props: {
    thisId: {
      type: Number,
      default: 0,
    },
    type: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    selected: {
      type: Boolean,
      default: false,
    },
    canUntoggle: {
      type: Boolean,
      default: false,
    },
    isBooked: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["select-station"],
  computed: {
    fillStyle() {
      return {
        umbrella: {
          yellow: `fill:${
            this.isBooked
              ? "#131111FF"
              : this.disabled
                ? "#bababa"
                : this.selected
                  ? "#ffea00"
                  : "#ffb856"
          };fill-rule:nonzero;`,
          red: `fill:${
            this.isBooked
              ? "#131111FF"
              : this.disabled
                ? "#808080"
                : this.selected
                  ? "#ff0000"
                  : "#ff990e"
          };fill-rule:nonzero;`,
        },
        station: {
          bottom: `fill:${
            this.isBooked
              ? "#131111FF"
              : this.disabled
                ? "#808080"
                : this.selected
                  ? "#ee4b2b"
                  : "#ff990e"
          };fill-rule:nonzero;`,
          left: `fill:${
            this.isBooked
              ? "#131111FF"
              : this.disabled
                ? "#8d8d8d"
                : this.selected
                  ? "#f05d40"
                  : "#ffa326"
          };fill-rule:nonzero;`,
          top: `fill:${
            this.isBooked
              ? "#131111FF"
              : this.disabled
                ? "#999999"
                : this.selected
                  ? "#f16f55"
                  : "#ffad3e"
          };fill-rule:nonzero;`,
          right: `fill:${
            this.isBooked
              ? "#131111FF"
              : this.disabled
                ? "#a6a6a6"
                : this.selected
                  ? "#f3816b"
                  : "#ffb856"
          };fill-rule:nonzero;`,
        },
      };
    },
    isSelected() {
      return this.selected && !this.disabled;
    },
  },
  methods: {
    buttonClicked() {
      if (this.disabled && !this.canUntoggle) {
        return false;
      }
      if (this.isBooked) {
        if (confirm("Sei sicuro di voler smarcare l'ombrellone comprato?")) {
          this.$emit("select-station", this.thisId);
        }
      } else {
        this.$emit("select-station", this.thisId);
      }
    },
  },
};
</script>

<style scoped>
.umbrella-button,
.station-button {
    width: 90%;
    height: 90%;
}

.umbrella-button.selected {
    width: 88%;
    height: 100%;
    border: 5px solid red;
    border-radius: 50%;
    padding: 15px;
}
</style>
